import {
  $DirectoryTraining,
  FetchGetDirectoryTrainingTable,
} from "@store/directory-programm-training";
import {
  $ProcedureTraining,
  FetchAllCategoriesForTrainingPrograms,
} from "@store/company/procedure-training-store";
import { memo, useEffect, useState } from "react";

import { AddCatedory } from "../add-catedory/add-catedory";
import { BodyNormal } from "@ui/fonts";
import { Button } from "@ui/button";
import { DirectoryVersion } from "../directory-version";
import DirectoryVersionService from "@services/version-service";
import { DropDownMultiSelect } from "@ui/drop-down";
import { OnSaveAll } from "../on-save-all";
import { ProgramTableT } from "@interfaces/directory/version";
import { TableProgramm } from "../table-programm/table-programm";
import styles from "./programm-training.module.scss";
import { useUnit } from "effector-react";
import { v4 as uuidv4 } from "uuid";
import { SELECTS_ID } from "@store/company/procedure-instrunctions-store";

type SelectListType = {
  id: number;
  title: string;
};

export const ProgrammTraining: React.FC = memo(() => {
  const TYPE = "training";
  const { training } = useUnit($DirectoryTraining);
  const directionLearning = useUnit($ProcedureTraining);
  const [openVersionLog, setOpenVersionLog] = useState<boolean>(false);
  const [lerningList, setLerningList] = useState<SelectListType[]>();
  const [stateSave, setStateSave] = useState<boolean>(false);
  const handlerLerningList = (values: SelectListType[]) => {
    setLerningList(values);
  };

  const updateCategory = () => {
    FetchGetDirectoryTrainingTable({});
    FetchAllCategoriesForTrainingPrograms({ isIncludeChanges: true });
  };

  useEffect(() => {
    updateCategory();
  }, []);

  const closeDownSave = () => setStateSave(false);

  const handlerProgramm = (choiceId: number) => {
    if (!!lerningList) {
      if (choiceId !== 0) {
        let categories = [choiceId];
        FetchGetDirectoryTrainingTable({ categories });
      }
      if (choiceId === 0) {
        let categories = lerningList
          .filter((item, pos) => lerningList.indexOf(item) === pos)
          .map((item) => item.id);

        FetchGetDirectoryTrainingTable({ categories });
      }
    }
  };

  useEffect(() => {
    if (!lerningList) {
      FetchGetDirectoryTrainingTable({});
    }
    if (training?.length && lerningList) {
      let categories = lerningList
        .filter(function (item, pos) {
          return lerningList.indexOf(item) === pos;
        })
        .map((item) => item.id);
      if (categories) {
        FetchGetDirectoryTrainingTable({ categories });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lerningList]);

  const viewOnSaveButton = () => {
    DirectoryVersionService.GetHaveAnyChanges(TYPE, (err, res) => {
      if (err || !res) {
        return Error(
          `При попытке отобразить кнопку для сохранения изменений ${TYPE} произошла ошибка`
        );
      }
      if (res.data) {
        setStateSave(res.data);
      }
    });
  };

  useEffect(() => {
    viewOnSaveButton();
  }, [training]);

  useEffect(() => {
    if (!directionLearning.categories) return;
    setLerningList(
      directionLearning.categories.filter((c) => c.id !== SELECTS_ID)
    );
  }, [directionLearning.categories]);

  return (
    <div className={styles.content}>
      {openVersionLog ? (
        <DirectoryVersion
          updateCategory={updateCategory}
          onClose={() => setOpenVersionLog(false)}
          type={TYPE}
        />
      ) : (
        <>
          <div className={styles.head}>
            <div className={styles.head_direction}>
              <AddCatedory
                list={lerningList}
                type={TYPE}
                handlerProgramm={handlerProgramm}
              />
              <div className={styles.head_select}>
                <DropDownMultiSelect
                  title={"Все категории"}
                  direction={directionLearning.categories ?? []}
                  handlerList={handlerLerningList}
                />
              </div>
            </div>
            <div className={styles.head_right}>
              <Button
                onClick={() => setOpenVersionLog(true)}
                className={styles.button_next}
              >
                <BodyNormal>Журнал версий справочника</BodyNormal>
              </Button>
            </div>
          </div>
          <div className={styles.tables}>
            {!!training &&
              training.map((item: ProgramTableT) => {
                return (
                  <TableProgramm
                    key={uuidv4()}
                    type={TYPE}
                    head={headTable}
                    id={item?.id}
                    action={item?.action}
                    title={item?.title}
                    change={item?.change}
                    programs={item.programs}
                  />
                );
              })}
          </div>
          {stateSave && (
            <OnSaveAll
              type={TYPE}
              updateCategory={updateCategory}
              closeDownSave={closeDownSave}
            />
          )}
        </>
      )}
    </div>
  );
});

type HeadTableT = {
  id: string;
  title: string;
}[];

const headTable: HeadTableT = [
  {
    id: "0",
    title: "№",
  },
  {
    id: "1",
    title: "полное наименование",
  },
  {
    id: "2",
    title: "первичное обучение",
  },
  {
    id: "3",
    title: "повторное обучение",
  },
  {
    id: "4",
    title: "",
  },
  {
    id: "5",
    title: "",
  },
];
